import { render, staticRenderFns } from "./viewORIJU.vue?vue&type=template&id=6fc176ea&scoped=true"
import script from "./viewORIJU.vue?vue&type=script&lang=js"
export * from "./viewORIJU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc176ea",
  null
  
)

export default component.exports